<template>
  <el-dialog
    :close-on-click-modal="false"
    title="日志信息"
    :visible.sync="showTaskLog"
    :before-close="handleCloseTaskLog"
    width="30%">
   <div>
     <p v-for="logItem in logContent">{{logItem}}</p>
   </div>
    <span slot="footer" class="dialog-footer">
     <el-button type="primary" @click="handleCloseTaskLog">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ['showTaskLog', 'logContent'],
  data() {
    return {

    }
  },
  created() {
  },
  methods: {
    handleCloseTaskLog () {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.$emit('callFather')
    }
  }

}


</script>

<style scoped>
.el-dialog div {
  max-height: 350px;
  overflow: auto;
}
</style>
